"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineTip = exports.InlineSuccess = exports.InlineWarning = exports.InlineError = exports.InlineMessage = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const IconTextSpan_1 = require("../icon-text-span/IconTextSpan");
const theme_1 = __importDefault(require("../styles/theme"));
const wrapperProps = {
    'tip': { 'bgColour': theme_1.default.colours.neutral.lightest, textColour: theme_1.default.colours.tip },
    'warning': { 'bgColour': 'rgba(255, 150, 0, 0.07)', textColour: 'rgba(137, 100, 46, 1)' },
    'success': { 'bgColour': theme_1.default.colours.success.tint, textColour: theme_1.default.colours.success.primary },
    'error': { 'bgColour': theme_1.default.colours.error.tint, textColour: theme_1.default.colours.error.primary },
};
const Wrapper = styled_1.default.div `
	display: inline-block;
	border-radius: 12px;
	padding: 2px 8px 2px 2px;
	background-color: ${({ bgColour }) => bgColour};
	color:  ${({ textColour }) => textColour};
	font-family: ${theme_1.default.typography.fonts.base};
`;
;
const InlineMessage = ({ text, icon, display, noIcon }) => {
    return (react_1.default.createElement(Wrapper, Object.assign({ "data-testid": `inline-${display}` }, wrapperProps[display]),
        react_1.default.createElement(IconTextSpan_1.IconTextSpan, { text: text, icon: icon, display: display, noIcon: noIcon })));
};
exports.InlineMessage = InlineMessage;
const InlineError = ({ text, noIcon }) => {
    return (react_1.default.createElement(exports.InlineMessage, { text: text, icon: "exclamation", display: "error", noIcon: noIcon }));
};
exports.InlineError = InlineError;
const InlineWarning = ({ text, noIcon }) => {
    return (react_1.default.createElement(exports.InlineMessage, { text: text, icon: "exclamation", display: "warning", noIcon: noIcon }));
};
exports.InlineWarning = InlineWarning;
const InlineSuccess = ({ text, noIcon }) => {
    return (react_1.default.createElement(exports.InlineMessage, { text: text, icon: "star", display: "success", noIcon: noIcon }));
};
exports.InlineSuccess = InlineSuccess;
const InlineTip = ({ text, noIcon }) => {
    return (react_1.default.createElement(exports.InlineMessage, { text: text, icon: "star", display: "tip", noIcon: noIcon }));
};
exports.InlineTip = InlineTip;
//# sourceMappingURL=InlineMessage.js.map